import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

import Icon from "shared/react_components/MaterialIcon";

import Styles from "./styles.module.scss";

const FilterDropdown = ({ label, applied, right, children, initialOpen, toggleClassName, onRemove, ...props }) => {
  const [isOpen, setOpen] = useState(initialOpen);
  const toggle = useCallback(() => setOpen(val => !val), []);

  const filterButtonClassNames = classNames({
    [Styles['filter-button-applied']]: applied,
    [Styles['filter-button-default']]: !applied,
    [Styles['filter-button-open']]: isOpen
  });

  return (
    <Dropdown data-id="filter-dropdown" isOpen={isOpen} toggle={toggle} {...props}>
      <DropdownToggle tag="span" data-id="filter-dropdown-toggle" className={classNames("d-flex btn", filterButtonClassNames, toggleClassName)} tabIndex="0">
        <span className="text-truncate">{label}</span>
        {onRemove && <Icon data-id="filter-remove" name="close" className={Styles['filter-remove']} onClick={onRemove} tabIndex="0"/>}
      </DropdownToggle>
      <DropdownMenu data-id="filter-dropdown-menu" right={right} flip={false}>
        <div className="my-2 mx-3">{children({ isOpen, toggle })}</div>
      </DropdownMenu>
    </Dropdown>
  );
};

FilterDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  applied: PropTypes.bool,
  right: PropTypes.bool,
  initialOpen: PropTypes.bool,
  toggleClassName: PropTypes.string,
  onRemove: PropTypes.func,
  children: PropTypes.func.isRequired
};

FilterDropdown.defaultProps = {
  applied: false,
  right: false,
  initialOpen: false
};

export default FilterDropdown;
